import { BottomSheetModal } from '@gorhom/bottom-sheet';
import {
  Query,
  ReplaceLostStolenCardInput,
  Typenames,
} from '@varo/graphql-schema-types';
import { useEffect, useRef } from 'react';
import fetchCardReviewDetails from 'services/graphql/queries/FetchCardReviewDetails';
import { AnyVariables, useQuery } from 'urql';

export interface CardReviewDetailsTypes {
  cardReviewDetails: ReplaceLostStolenCardInput;
}

const useCardDetails = (cardId: string, cardAction: string) => {
  const bottomSheetRef = useRef<BottomSheetModal>(null);

  const handlePresentBottomSheet = () => {
    bottomSheetRef?.current?.present();
  };

  const handleCloseBottomSheet = () => {
    bottomSheetRef?.current?.close();
  };

  const [{ data, fetching: loading, error: cardReviewError }, refetch] =
    useQuery<Query, AnyVariables>({
      query: fetchCardReviewDetails,
      requestPolicy: 'cache-and-network',
      variables: {
        cardId: cardId,
        cardAction: cardAction,
      },
      pause: true,
    });

  const togglePause = () => {
    refetch();
  };

  useEffect(() => {
    if (cardAction) {
      refetch();
    }
  }, [cardAction, refetch]);

  const cardReviewDetailsSuccess =
    data?.cardReviewDetails?.__typename === Typenames.CardReviewDetailsSuccess
      ? data.cardReviewDetails
      : null;

  const cardReviewDetailsError =
    data?.cardReviewDetails?.__typename === Typenames.CardReviewDetailsError
      ? data.cardReviewDetails
      : null;
  return {
    cardReviewDetailsSuccess,
    cardReviewDetailsError,
    cardReviewError,
    loading,
    togglePause,
    handlePresentBottomSheet,
    handleCloseBottomSheet,
    bottomSheetRef,
  };
};

export default useCardDetails;
